// extracted by mini-css-extract-plugin
export default {"sideNavigation":"SideNavigation_sideNavigation__0eOnh"};